var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.65 14.25V14.35H0.75H2H2.1V14.25C2.1 11.5367 4.28667 9.35 7 9.35C9.71333 9.35 11.9 11.5367 11.9 14.25V14.35H12H13.25H13.35V14.25C13.35 11.0835 11.0121 8.44588 7.97418 7.97483C9.62573 7.54158 10.85 6.03431 10.85 4.25C10.85 2.12934 9.12066 0.4 7 0.4C4.87934 0.4 3.15 2.12934 3.15 4.25C3.15 6.03431 4.37427 7.54158 6.02582 7.97483C2.98786 8.44588 0.65 11.0835 0.65 14.25ZM7 1.85C8.33149 1.85 9.4 2.91851 9.4 4.25C9.4 5.58149 8.33149 6.65 7 6.65C5.66851 6.65 4.6 5.58149 4.6 4.25C4.6 2.91851 5.66851 1.85 7 1.85Z",
    fill: "#3282B8",
    stroke: "#3282B8",
    strokeWidth: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/UserIcon.0e5c6b952739d9572a5025867e39fbec.svg";
export { ForwardRef as ReactComponent };